import { render, staticRenderFns } from "./EliminacionMultipleModal.vue?vue&type=template&id=3c7a2d96"
import script from "./EliminacionMultipleModal.vue?vue&type=script&lang=js"
export * from "./EliminacionMultipleModal.vue?vue&type=script&lang=js"
import style0 from "./EliminacionMultipleModal.vue?vue&type=style&index=0&id=3c7a2d96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports